
<div *ngIf="q.format && q.format== 'vid'" class="my-2 text-center">
     <app-vid-dtl class= "" [q] = q> </app-vid-dtl>
</div>
